import { render, staticRenderFns } from "./NewTextPropertyEditor.vue?vue&type=template&id=c5ace56e&scoped=true&"
import script from "./NewTextPropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./NewTextPropertyEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ace56e",
  null
  
)

export default component.exports